import {
    List,
    ListItemButton,
    ListItemText,
    ListSubheader,
} from '@mui/material'
import { IDocument } from 'hooks/useHelpDocument/useHelpDocument'

export default function Navigation({
    docList,
    selectDocId,
    onSelectDocId,
}: {
    docList: Record<string, IDocument[]>
    selectDocId: number
    onSelectDocId: (docId: number) => void
}) {
    return (
        <>
            {Object.keys(docList).map((key) => (
                <List
                    key={key}
                    component="nav"
                    disablePadding
                    subheader={
                        <ListSubheader
                            sx={{ color: 'primary.main', fontWeight: 700 }}
                        >
                            {key.toUpperCase()}
                        </ListSubheader>
                    }
                >
                    {docList[key].map((doc) => (
                        <ListItemButton
                            key={doc.id}
                            onClick={() => onSelectDocId(doc.id)}
                            selected={selectDocId === doc.id}
                        >
                            <ListItemText primary={doc.title} />
                        </ListItemButton>
                    ))}
                </List>
            ))}
        </>
    )
}
